import { AdminFeatureFlagsName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getAdminFeatureFlagsAll } from '../../api';

export const getAdminFeatureFlagsSlice = createGetAsyncSlice({
	name: AdminFeatureFlagsName,
	receive: true,
	request: false,
	requestHandler: getAdminFeatureFlagsAll,
	retainDataOnRequest: true
});
